import * as asyncActions from './thunks';
import * as actions from './slice';
export * as userSelectors from './selectors';

export const userActions = {
    ...asyncActions,
    ...actions,
};
